<div class="post__details flex flex-col gap-4">
  <h1 [innerText]="landingPageDataService.details().pageInfo.title"></h1>

  <app-ad [ad-width]="728" [ad-height]="90"></app-ad>

  @if (landingPageDataService.isQrCode()) {
    <div class="qr__card">
      <img [src]="landingPageDataService.details().url" alt="qr-code" />
    </div>
  }

  <div class="qr__desc" [innerHTML]="safeHtml()"></div>
</div>
